/** Picks v2 or v1 of the Research User Feedback page based on the redesign flag. */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import ResearchUserFeedbackPage   from './ResearchUserFeedbackPage';
import ResearchUserFeedbackPageV2 from './v2/ResearchUserFeedbackPageV2';

export default function ResearchUserFeedbackPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? ResearchUserFeedbackPageV2 : ResearchUserFeedbackPage;
  return <Component {...props} />;
}
